import gql from 'graphql-tag'

export const FEATURE_FLAGS_QUERY = gql`
    query FeatureFlags {
        listFeatureFlags {
            items {
                id
                enabled
                code
                name
            }
        }
    }
`
